import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AUTH } from '../contants/AUTH';
import { CACHE_KEYS } from '../contants/CACHE_KEYS';
import { CacheService } from './cache.service';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';

@Injectable()
export class AuthenticationService {
	isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private origin: string = environment.API_BASE_URL;

	constructor(
		private _httpClient: HttpClient,
		private _cacheService: CacheService,
		private _messagesService: MessagesService,
		private _logService: LogService
	) { }

	login(username: string, password: string) {
		let headers = new HttpHeaders()
			.set('Content-Type', 'application/x-www-form-urlencoded');

		let body = new HttpParams()
			.set('username', username)
			.set('password', password)
			.set('grant_type', 'password');

		return this._httpClient.post<any>(this.origin + '/oauth2/token', body.toString(), { headers: headers })
			.map(response => {
				if (response) {
					if (response['access_token']) {
						this._cacheService.remove(CACHE_KEYS.rightsResult);
						localStorage.setItem(AUTH.token, response['access_token']);
						// localStorage.setItem(AUTH.tokenExpiration, response['expires_in']);
						var dateNow = new Date();
						dateNow.setHours(dateNow.getHours() + 10)
						localStorage.setItem(AUTH.tokenExpiration, dateNow.toString());
						localStorage.setItem(AUTH.username, username);

						this.isLoggedIn.next(true);
					}
				}

				return response;
			});
	}

	logout() {
		localStorage.clear();
		this.isLoggedIn.next(false);
	}
	
	checkRights(): Observable<boolean> {
		let value = this._cacheService.get(CACHE_KEYS.rightsResult)
		if (value != null) {
			return of(value);
		}

		return this._httpClient.get<boolean>(`${this.origin}/api/users/current/rights`)
			.pipe(
				tap(x => {
					this.log(`checkRights`);
					this._cacheService.add(CACHE_KEYS.rightsResult, x, 360);
				}),
				catchError(this._logService.handleError<boolean>('checkRights'))
			);
	}

	isTokenExpired(): boolean {
		var tokenExpire = localStorage.getItem(AUTH.tokenExpiration);
		if(tokenExpire != null){
			var dateNow = new Date();
			var dateExpire = new Date(tokenExpire);
			if(dateNow < dateExpire){
				this.isLoggedIn.next(true);
				return false;
			}
		}

		this.logout();
		return true;
	}

	private log(message: string) {
		this._messagesService.add('UserService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts